module.exports = {
    naam: '',
    email: '',
    bericht: "",
    telefoonnummer: '',
    straat: '',
    postcode: '',
    woonplaats: '',

    auto: {
        merk: 'Renault',
        model_type: '',
        kenteken: '',
        brandstof: '',
        kilometerstand: '',
        datum_deel_1: '',
        transmissie: '',
        kleur_exterieur: '',
        metallic_lak: '',
        kleur_interieur: '',
        type_interieur: '',
        beschadigdheden_mankementen: '',
        opmerkingen: ''
    },
};
